<div class="dropdown">
	<button class="btn btn-link text-decoration-none bg-white ps-3 dropdown-toggle style-btn" type="button"
		data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"
		id="dropdownMenuClickableInside">
		@if (dateRange().start || dateRange().end) {
			Submission Date:
			<span class="text-info text-wrap">{{ dateRangeDisplay() }}</span>
			<button type="button" class="btn-close mx-2 my-1 p-0" aria-label="Close" (click)="clearFilter()"></button>
		} @else {
			<span class="me-3">Any Submission Date</span>
		}
	</button>
	<div class="dropdown-menu p-0" aria-labelledby="dropdownMenuClickableInside" #dropdownList>
		<div class="date-range-presets">
			<div class="d-none d-sm-block list-group list-group-flush">
				@for (dateRangePreset of dateRangePresets; track dateRangePreset.label) {
					<a class="list-group-item" href="javascript:void(0);" (click)="onSelectDateRangePreset(dateRangePreset)">
						<span class="d-inline-block me-auto">
							{{ dateRangePreset.label }}
						</span>
						@if (dateRangePreset.selected) {
							<fa-icon [icon]="faCheck()"></fa-icon>
						}
					</a>
				}
			</div>

			<div class="d-block d-sm-none mb-3">
				<select class="custom-select" (change)="onSelectDateRangePresetByLabel($event)">
					@for (dateRangePreset of dateRangePresets;track dateRangePreset.label) {
						<option [value]="dateRangePreset.label" [selected]="dateRangePreset.selected">
							{{ dateRangePreset.label }}
						</option>
					}
				</select>
			</div>
		</div>

		<div class="date-range-calendar">
			<owl-date-time-inline pickerType="calendar" selectMode="range"
				[(ngModel)]="selectedDateRange" (ngModelChange)="onDateRangeChange($event)"
			></owl-date-time-inline>

			<div class="border-top text-end p-2">
				<button type="button" class="btn btn-outline me-2" (click)="closeDropdown($event)">
					Cancel
				</button>
				<button type="button" class="btn btn-primary" (click)="onApply(); closeDropdown($event)">
					Apply
				</button>
			</div>
		</div>
	</div>
</div>
